import React, {FunctionComponent} from 'react';
import {Intent, FormGroup, InputGroup} from '@blueprintjs/core';

import {IUser} from '../../../../../shared/models';
import {isAdmin} from '../../../../../shared/utils/auth';
import {
  IOnboardingFormState,
  IOnboardingFormStateErrors,
} from './OnboardingDialog';

interface IOnboardingStep1Props {
  formState: IOnboardingFormState | null;
  formStateErrors: IOnboardingFormStateErrors;
  onChangeInput: any;
  currentUser: IUser;
}

const CompleteProfileStep: FunctionComponent<IOnboardingStep1Props> = ({
  currentUser,
  formState,
  formStateErrors,
  onChangeInput,
}: IOnboardingStep1Props) => {

  if (!formState) {
    return null;
  }

  const helperText = (field: boolean) => {
    return field ? '' : 'Minimum of 2 characters required.';
  };

  return (
    <div className="complete-profile__content">
      <div className="complete-profile__content__name-part">
        <FormGroup
          label="First Name"
          labelInfo="(required)"
          helperText={helperText(formStateErrors.firstName)}
        >
          <InputGroup
            id="first_name"
            placeholder="First Name"
            intent={formStateErrors.firstName ? Intent.NONE : Intent.DANGER}
            maxLength={20}
            value={formState.firstName}
            onChange={e => onChangeInput('firstName', e.target.value)}
          />
        </FormGroup>

        <FormGroup
          label="Last Name"
          labelInfo="(required)"
          helperText={helperText(formStateErrors.lastName)}
        >
          <InputGroup
            id="last_name"
            placeholder="Last Name"
            intent={formStateErrors.lastName ? Intent.NONE : Intent.DANGER}
            value={formState.lastName}
            onChange={e => onChangeInput('lastName', e.target.value)}
          />
        </FormGroup>
      </div>
      {isAdmin(currentUser) && (
        <>
          <FormGroup
            label="Workspace name"
            helperText={helperText(formStateErrors.companyName)}
          >
            <InputGroup
              id="company_name"
              placeholder="Acme Inc."
              intent={formStateErrors.companyName ? Intent.NONE : Intent.DANGER}
              value={formState.companyName}
              onChange={e => onChangeInput('companyName', e.target.value)}
            />
          </FormGroup>
        </>
      )}
    </div>
  );
};

export default CompleteProfileStep;
